import { api, apiUrl } from "./../../api/index";

const url = `${apiUrl}/representants`;

export const fetchRepresentants = async () => {
  return api(url, {
    method: "GET",
  }).then((res) => res.json());
};
